<template>
  <ReflectionCard :inSession="inSession">
    <template #header>
      <span>{{ inSession ? 'Reflection' : 'What?' }}</span>
    </template>
    <template #content>
      <textarea
        ref="whatRef"
        :rows="inSession ? null : 4"
        v-model="what_field"
        @input="onInput"
        class="w-full border border-gray-200 rounded text-sm resize-none overflow-hidden"
        style="min-height: 6rem"
        :placeholder="
          inSession
            ? 'Notes taken in the reflection tab will be available in your reflection page after the session'
            : ''
        "
      ></textarea>
    </template>
  </ReflectionCard>
</template>

<script>
import ReflectionCard from './Components/ReflectionCard.vue';

export default {
  name: 'WhatCard',
  components: { ReflectionCard },
  props: {
    initialValue: {
      type: String,
      default: null,
    },
    inSession: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.whatRef;
      if (!el) return;

      const observer = new ResizeObserver(() => {
        if (el.offsetParent !== null) {
          this.autoResize();
          observer.disconnect();
        }
      });
      observer.observe(el);
    });
  },
  data() {
    return {
      what_field: this.initialValue ?? this.$page.props.session.reflection?.what,
    };
  },
  watch: {
    what_field: {
      immediate: true,
      handler() {
        if (this.$refs.whatRef?.offsetParent !== null) {
          this.$nextTick(this.autoResize);
        }
      },
    },
  },
  methods: {
    emitFieldChange() {
      this.$emit('fieldChanged', {
        field: 'what',
        value: this.what_field,
      });
    },
    onInput() {
      this.autoResize();
      this.emitFieldChange();
    },
    autoResize() {
      const el = this.$refs.whatRef;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },
  },
};
</script>

<style scoped></style>
